// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_pdV","cls2":"Header-cls2_WKv Header-cls1_pdV"};